/**
 * REUSABLE COMPONENT - Badge
 * Generic badge/pill component for status display
 * Can be used in any React project
 */

import React from 'react';
import { STATUS_COLORS, STATUS_LABELS } from '../../utils/constants';

const Badge = ({
  children,
  status,
  variant = 'default',
  size = 'md',
  dot = false,
  rounded = true,
  className = '',
}) => {
  // Base classes
  const baseClasses = 'inline-flex items-center font-medium';

  // Get colors from status or use variant - Couleurs Zitelou
  const colors = status ? STATUS_COLORS[status] : {
    bg: variant === 'none' ? 'bg-gray-100' :
        variant === 'success' ? 'bg-green-100' :
        variant === 'error' ? 'bg-red-100' :
        variant === 'warning' ? 'bg-orange-100' :
        variant === 'info' ? 'bg-blue-100' :
        'bg-gray-100',
    text:   variant === 'none' ? 'text-gray-800' :
            variant === 'success' ? 'text-green-800' :
           variant === 'error' ? 'text-red-800' :
           variant === 'warning' ? 'text-orange-800' :
           variant === 'info' ? 'text-blue-800' :
           'text-gray-800',
    dot: variant === 'none' ? 'bg-none':
        variant === 'success' ? 'bg-success' :
         variant === 'error' ? 'bg-danger' :
         variant === 'warning' ? 'bg-warning' :
         variant === 'info' ? 'bg-primary' :
         'bg-gray-500',
  };

  // Size classes
  const sizeClasses = {
    xs: 'px-2 py-0.5 text-xs',
    sm: 'px-2.5 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm',
    lg: 'px-4 py-1.5 text-base',
  };

  // Rounded classes
  const roundedClass = rounded ? 'rounded-full' : 'rounded';

  // Combine classes
  const badgeClasses = `${baseClasses} ${colors.bg} ${colors.text} ${sizeClasses[size]} ${roundedClass} ${className}`;

  // Get label text
  const label = children || (status ? STATUS_LABELS[status] : '');

  return (
    <span className={badgeClasses}>
      {dot && (
        <span className={`w-2 h-2 rounded-full mr-1.5 ${colors.dot}`}></span>
      )}
      {label}
    </span>
  );
};

export default Badge;
